module.exports = __webpack_public_path__ + "static/media/Frame.e536e33d.svg";